export const trimDecimals = (value, precision = 2) => {
    const pow = 10 ** precision;
    return Math.round(value * pow) / pow;
};
//# sourceMappingURL=trimDecimals.js.map